import { library } from '@fortawesome/fontawesome-svg-core';
import { 
    faVolumeUp, 
    faBook, 
    faStar, 
    faSpinner, 
    faUsers,
    faArrowUp,
    faComment,     
    faLanguage,      
    faComments,     
    faBrain,        
    faBookOpenReader,    
    faTasks,        
    faFaceGrinStars,  
    faBookOpen,       
    faMusic,       
    faPencilAlt,   
    faSmile,       
    faHeadphones,
    faPlay,
    faPause,
    faStop,
    faQuestionCircle,
    faKey,               
    faExclamationTriangle,
    faArrowLeft,
    faArrowRight,
    faCheck,
    faXmark,
    faRightFromBracket,
    faDeleteLeft,
    faSpellCheck,
    faEllipsis,
    faEllipsisVertical,
    faCaretLeft,
    faCaretRight,
    faStroopwafel,
    faInfoCircle,
    faChevronDown,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(
    faVolumeUp, 
    faBook, 
    faStar, 
    faSpinner, 
    faUsers,
    faArrowUp,
    faComment,       
    faLanguage,     
    faComments,    
    faBrain,         
    faBookOpenReader, 
    faTasks,           
    faFaceGrinStars, 
    faBookOpen,      
    faMusic,        
    faPencilAlt,    
    faSmile,        
    faHeadphones,
    faPlay,
    faPause,
    faStop,
    faQuestionCircle,
    faKey,           
    faExclamationTriangle,
    faArrowLeft,
    faArrowRight,
    faCheck,
    faXmark,
    faRightFromBracket,
    faDeleteLeft,
    faSpellCheck,
    faEllipsis,
    faEllipsisVertical,
    faCaretLeft,
    faCaretRight,
    faStroopwafel,
    faInfoCircle,
    faChevronDown,
);

export { FontAwesomeIcon };